import axios from "axios";
import React, { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { post } from "../common/api";
import { ReactComponent as BookmarkSvg } from "../logo/BookmarkPrimary.svg";
import { ReactComponent as BookmarkedSvg } from "../logo/BookmarkedWithoutBorder.svg";

import './PoiPage.css';
import { stringToBoolean } from "../common/utils";


export function AddToBucketListButton(props) {
    const { poiId } = props;
    const auth = useSelector(state => state.auth);
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const [isBookmarked, setIsBookmarked] = useState(false);

    const alert = useAlert();

    async function adjustBucketList(action) {
        setIsLoading(true);
        try {
            const res = await post(`/api/bucket-list/${action}`, { poi_id: poiId }, {
                headers: { 'Authorization': `Token ${auth.token}` },
            });
            const { message } = res.data;
            alert.success(message, { timeout: 1000 });
            setIsBookmarked(!isBookmarked);            
        } catch (e) {
            const message = e.response?.data?.message || "An error occured, please try again";
            alert.error(message);
        }
        setIsLoading(false);
    }

    async function onClick() {
        if (!auth.isAuthenticated) {
            alert.info("Silahkan login terlebih dahulu untuk menambahkan item ke bucket list.");
            history.push('/login');
            return;
        }
        if (isBookmarked) await adjustBucketList('remove');
        else await adjustBucketList('add');
    }

    useEffect(() => {
        if (auth && !auth.isAuthenticated) {
            setIsLoading(false);
            return;
        }
        const source = axios.CancelToken.source();
        async function fetchBookmarkStatus() {
            setIsLoading(true);
            try {
                const { data } = await post('/api/bucket-list/check', {
                    poi_id: poiId,
                }, {
                    headers: {
                        'Authorization': `Token ${auth.token}`
                    },
                    cancelToken: source.token,
                })
                const { message } = data;
                setIsBookmarked(stringToBoolean(message));
            } catch (error) {
                alert.error(error.toString());
            }
            setIsLoading(false);
        }
        fetchBookmarkStatus();
        return () => source.cancel();
    }, [auth, alert, poiId]);

    if (isLoading) {
        return <button className="poi-action-button secondary-button" disabled>
            <div className="d-flex justify-content-center align-self-center w-100">
                <div className="spinner-border" role="status" />
            </div>    
        </button>;
    }
    return (
        <button className="poi-action-button secondary-button" onClick={onClick}>
            {isBookmarked ? <BookmarkedSvg /> : <BookmarkSvg />}
            {isBookmarked ? <span>Hapus dari Bucket List</span> : <span>Tambah ke Bucket List</span>}
        </button>
    );
}
